define('editor/edit/layers/edit/textblock',['./layerBase', 'knockout', 'knockout-mapping', 'plugins/http', 'durandal/app', 'jquery', 'summernote'], function (layerBase, ko, komapping, http, app, $) {
    var viewmodel = function () {
        var self = this;
        
        var moduleId = self.__moduleId__;
        self.base = new layerBase();
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;

        self.layer = null;
        self.html = ko.observable('');
        self.jqteChangeHandler = null;

        self.activate = function (editorMapId, layer, backToListFunc) {
            self.base.activate(editorMapId, layer, backToListFunc);
            self.editorMapId = editorMapId;
            self.layer = layer;
            self.html(self.layer.state().html());
        };

        self.compositionComplete = function () {
            var options = {
                toolbar: [
                    ['color', ['color']],
                    ['style', ['style', 'bold', 'italic', 'underline', 'strikethrough', 'clear']],
                    ['para', ['ul', 'ol', 'paragraph']]
                ],
                height: 300,
                minHeight: null,
                maxHeight: null,
                focus: true,
                onChange: function (contents) {
                    self.layer.state().html(contents);

                    app.trigger("layers:updated", [self.layer]);
                }
            };

            $('.text-block-editor').summernote(options);
        };
    };

    return viewmodel;
});

